export default __webpack_public_path__ + "static/media/frame-300.e3a23ada.gif";